module.exports = __webpack_public_path__ + "static/media/punch.951abdef.mp3";